import React, { useEffect, createElement, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { IngredientDemo } from './components/IngredientDemo';
import { DownloadCTA } from './components/DownloadCTA';
import { Footer } from './components/Footer';
import { BlogPage } from './components/BlogPage';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { ContactSupport } from './components/ContactSupport';
// Component to handle scrolling to hash links when navigating from another page
function ScrollToHash() {
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [hash]);
  return null;
}
function HomePage() {
  useEffect(() => {
    document.title = 'IntelliEats — Scan Ingredients, Eat Smarter';
    const meta = document.createElement('meta');
    meta.name = 'google-adsense-account';
    meta.content = 'ca-pub-3041826185319356';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return <main data-id="element-0">
      <HeroSection data-id="element-1" />
      <HowItWorks data-id="element-2" />
      <Features data-id="element-3" />
      <IngredientDemo data-id="element-4" />
      <DownloadCTA data-id="element-5" />
    </main>;
}
export function App() {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = 'https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp';
  }, []);
  return <BrowserRouter data-id="element-6">
      <ScrollToHash data-id="element-7" />
      <div className="min-h-screen bg-white" data-id="element-8">
        <Navbar data-id="element-9" />
        <Routes data-id="element-10">
          <Route path="/" element={<HomePage data-id="element-12" />} data-id="element-11" />
          <Route path="/blog" element={<BlogPage data-id="element-14" />} data-id="element-13" />
          <Route path="/privacy" element={<PrivacyPolicy data-id="element-16" />} data-id="element-15" />
          <Route path="/terms" element={<TermsOfService data-id="element-18" />} data-id="element-17" />
          <Route path="/contact" element={<ContactSupport data-id="element-20" />} data-id="element-19" />
        </Routes>
        <Footer data-id="element-21" />
      </div>
    </BrowserRouter>;
}